<template>
    <div id="cnib_main">
        <button v-show="!editmode" @click="startNew" id="cnib_button" class="bt bt-normal bt-hover-dark bg-main fc-white">
            <slot></slot>
        </button>
        <div v-show="editmode" id="cnib_editing">
            <input v-model="data" type="text" class="bg-faded" @keypress.enter="confirm" ref="cnibinput">
            <div id="cnib_editing_confirm" @click="confirm">
                <i v-if="data" class="fas fa-plus-square fc-main fs-bigger bt-hover-dark"></i>
                <i v-else class="fas fa-caret-square-left fc-main fs-bigger bt-hover-dark"></i>
            </div>
        </div>
    </div>
</template>

<script>
export default {
  name: 'createNewInputButton',
  data () {
    return {
      editmode: false,
      data: ''
    }
  },
  methods: {
    startNew () {
      this.editmode = true
      setTimeout(() => {
        this.$refs.cnibinput.focus()
      }, 0)
    },
    confirm () {
      this.editmode = false
      if (this.data) {
        this.$emit('confirm', this.data)
      }
      this.data = ''
    }
  }
}
</script>

<style scoped>
    #cnib_main{
        display: flex;
        width: calc(100% - 20px);
        height: 40px;
    }
    #cnib_button{
        display: flex;
        justify-content: center;
        width: 100%;
        height: 100%;
    }
    #cnib_editing{
        display: flex;
        position: relative;
        height: 100%;
        width: 100%;
    }
    #cnib_editing input{
        display: flex;
        height: calc(100% - 4px);
        width: 100%;
        border: 1px solid var(--color-gray);
        padding-left: 10px;
        padding-right: 35px;
    }
    #cnib_editing_confirm{
        display: flex;
        position: absolute;
        right: 5px;
        height: 100%;
        align-items: center;
        justify-content: center;
        cursor: pointer;
    }
</style>
